import config from "@/config";


export interface ApiError {
    message?: string;
    messages?: string[];
}

const API_URL = config.baseUrl;


export class BaseApi {
    constructor(private isFormData?: boolean) {
        this.isFormData = false;
    }

    private async handleErrors<T>(response: Response): Promise<any> {
        if (response.ok) {
            return response.json();

        }
        const error: ApiError = await response.json();
        return error.message ? error.message : error.messages  ?? error
    }

    protected async fetch<T>(endpoint: string, options: RequestInit = {}): Promise<any> {
        // console.log(`${API_URL}${endpoint}`)
        try {
            const response = await fetch(`${API_URL}${endpoint}`, {
                ...options,
                headers: {
                    ...(this.isFormData
                        ? {}
                        : {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        }),
                    ...options.headers,
                },
            });
            return this.handleErrors<T>(response);
        } catch (error) {
            return Promise.reject(error);
        }


    }

    protected get<T>(endpoint: string, options?: RequestInit): Promise<T> {
        return this.fetch<T>(endpoint, {...options, method: 'GET'});
    }


    protected post<T>(endpoint: string, body: any, options?: RequestInit): Promise<T> {
       try {
           if (body) {
               return this.fetch<T>(endpoint, {
                   ...options,
                   method: 'POST',
                   body: this.isFormData ? body : JSON.stringify(body),
               });
           }else {
               return Promise.reject("body : is empty");
           }
       }catch (error) {
           return Promise.reject(error);
       }
    }

    protected postFormData<T>(endpoint: string, body: any, options?: RequestInit): Promise<T> {
        this.isFormData = true
        return this.fetch<T>(endpoint, {
            ...options,
            method: 'POST',
            body: body,
        });
    }

    protected put<T>(endpoint: string, body: any, options?: RequestInit): Promise<T> {
        return this.fetch<T>(endpoint, {
            ...options,
            method: 'PUT',
            body: JSON.stringify(body),
        });
    }


    protected delete<T>(endpoint: string, options?: RequestInit): Promise<T> {
        return this.fetch<T>(endpoint, {...options, method: 'DELETE'});
    }

    protected urlBuilder(
        base: string,
        params: Record<string, string | number | (string | number)[] | null>,
        mergeDuplicates: boolean = false
    ) {
        const queryString = Object.entries(params)
            .filter(([_, value]) => value !== null && value !== undefined && value !== "")
            .flatMap(([key, value]) => {
                if (Array.isArray(value)) {
                    return mergeDuplicates
                        ? `${encodeURIComponent(key)}=${encodeURIComponent(value.join(","))}`
                        : value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(value!)}`;
            })
            .join("&");

        return queryString ? `${base}?${queryString}` : base;
    }


}
